import type React from 'react';

import { GooglePlacesProviderLegacy } from '#src/app/shared/hooks/googlePlaces';

import { PlaceField } from './PlaceField';
import type { PlaceFieldProps } from './PlaceField';

export const PlaceFieldWrapper: React.FC<PlaceFieldProps> = (props) => {
	return (
		<GooglePlacesProviderLegacy>
			<PlaceField {...props} />
		</GooglePlacesProviderLegacy>
	);
};
